import Vue from 'vue'
import App from './App.vue'
import router from './router'
import resource from 'vue-resource'
import store from './store/store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import 'swiper/dist/css/swiper.css'
//引入一个淡入淡出效果的css
import './directive/collapse-transition/collapse-transition.css'

import iView from 'iview';
import 'iview/dist/styles/iview.css';
import '../src/css/commit/font/iconfont.css' // 字体样式
import '../src/css/commit/fonts/iconfont.css' // 字体样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(iView);
Vue.use(ElementUI)
import './css/customize.less'; // 引入一些自定义的css，用于改变一些框架的样式。比如说noUIslider滑块组件
if (!String.prototype.padStart) {
	String.prototype.padStart = function padStart(targetLength, padString) {
		targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
		padString = String((typeof padString !== 'undefined' ? padString : ''));
		if (this.length > targetLength) {
			return String(this);
		}
		else {
			targetLength = targetLength - this.length;
			if (targetLength > padString.length) {
				padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
			}
			return padString.slice(0, targetLength) + String(this);
		}
	};
}

// 在vue原型链上增加方法和属性
import MyPlugin from './js/plugin.js';

Vue.use(MyPlugin);

Vue.use(resource);
// 这三行是强制post的请求变成表单提交，因为有些后台接口必须使用表单提交formData。
Vue.http.options.emulateJSON = true;
Vue.http.options.crossOrigin = true;
Vue.http.options.emulateHTTP = true;
// resouce拦截器   必须在use后面加入
Vue.http.interceptors.push(function (request, next) {
	next((response) => {
		// 如果返回的数据是-1  说明是未登录状态   某些有登录限制的页面不能进去  要跳出来
		if (response.data === -1) {
			if (location.href.search(/lottery|userCenter/) > -1) {
				this.$router.push({path: '/'})
				console.log('未登录，拦截器拦截')
			}
		}
		return response
	});
})



Vue.config.productionTip = false
Vue.use(resource)
Vue.use(VueAwesomeSwiper)
Vue.use(VueClipboard)

// import {loadScript} from '@/js/common'

// loadScript('/yx/app/getCustomerService?name=AppInit', function () {
	// appConfig.speedSrc = AppInit.urls.split(',')
	// appConfig.serverhref = AppInit.kefu
	// appConfig.title = AppInit.name
	var app = new Vue({
		el: '#app',
		router,
		template: '<App/>',
		components: {App},
		store
	})
// })



// WEBPACK FOOTER //
// src/main.js